import { render, staticRenderFns } from "./BackgroundNetwork.vue?vue&type=template&id=ff84f210&scoped=true&"
import script from "./BackgroundNetwork.vue?vue&type=script&lang=js&"
export * from "./BackgroundNetwork.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundNetwork.vue?vue&type=style&index=0&id=ff84f210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff84f210",
  null
  
)

export default component.exports